module.exports = __webpack_public_path__ + "static/media/self_defense_pen.adf0bf36.jpg";